import {
  IGetScheduleByUserResponse200,
  TGetScheduleByUserResponse,
} from '../../../repositories/work-time/v1/get-schedule-by-user';
import { mapResponseErrors, ResponseError } from '../../../utils/errors';

export function assertResponseError(
  response: TGetScheduleByUserResponse,
): asserts response is IGetScheduleByUserResponse200 {
  if (response.statusCode !== 200) {
    const { message, errors } = response.response;

    throw new ResponseError({
      domain: 'shared.services.getWorkTimeSchedule()',
      message: message as string,
      details: mapResponseErrors(errors as any[]),
    });
  }
}
